import {useState} from 'external/react'
import {
  clsx
 ,Box
 ,Fade
 ,Table 
 ,TableContainer 
 ,TableBody 
 ,TableRow 
 ,TableCell 
 ,FiberManualRecordIcon 
} from 'external/material'

import {inViewer} from 'settings'
import UploadedLinks from './UploadedLinks'
import LessonLinks from 'components/MyCourses/LessonLinks'
import LessonsHead from './LessonsHead'
import Message from 'components/Message'

import useStudentContext from 'hooks/student'
import useTranslations from 'hooks/translations'
import useCatalog from 'hooks/catalog'

export default function Lessons() {
  const [[openMessage, anchorEl], setOpenMessage] = useState([-1, null])
  const {isDownloaded} = useCatalog()
  const {content} = useStudentContext()
  const {formatDate} = useTranslations()
 
  const getMessage = () => {
    const assignment = content[openMessage]
    const isUploaded = !!assignment.content.url
    const lesson = isUploaded
      ? assignment.content.title
      : assignment.lesson
    const title = isUploaded 
      ? assignment.content.title
      : assignment.name
    const text = assignment.content.message
    return {date: formatDate(assignment.date), lesson, title, text}
  }

  const message = openMessage > -1 ? getMessage() : {}
  

  return (
    <Box className="lessons">
      <Message open={openMessage > -1} anchorEl={anchorEl} {...message} onClose={() => setOpenMessage([-1, null])} />
      <TableContainer className="lessonsTableContainer">
        <Table stickyHeader className="lessonsTable">
          <LessonsHead />
          <Fade in={content.length > 0}>
          <TableBody>
            {content.map((assignment, i) => {
              const downloaded = isDownloaded({id: assignment.lesson || assignment.id, hash: assignment.hash})
              const isUploaded = !!assignment.content.url
              const lessonName = assignment.content.title || assignment.name
              return (<TableRow key={i}>
                <TableCell className="nameCell" align="left">
                  {inViewer && <span className={clsx("lessonIcon", {downloaded})}><FiberManualRecordIcon /></span>}
                  <span className={clsx("lessonName",{downloaded})}>{lessonName}</span>
                </TableCell>
                <TableCell align="left"><span className={"date"}>{formatDate(assignment.date)}</span></TableCell>
                <TableCell align="center"><span className={"actions"}>
                  {!isUploaded && <LessonLinks onMessageClick={target => {
                    setOpenMessage([i, target])
                  }} {...{id: assignment.lesson, hasEpl: assignment.hasEpl, events: [assignment.id], scheduled: true, downloaded}} />}
                  {isUploaded && <UploadedLinks onMessageClick={target => {
                    setOpenMessage([i, target])
                  }} assignment={assignment} downloaded={downloaded} />}
                </span></TableCell>          
              </TableRow>)
            })}
          </TableBody>
          </Fade>
        </Table>
      </TableContainer>
    </Box>
  )
}
